import * as React from 'react';
import { ForwardedRef } from 'react';

export const INPUT_DEFAULT_RIGHT_SIZE_PADDING = 'px-4';
const INPUT_DEFAULT_RIGHT_SIZE_PADDING_NUMERIC_VALUE =
  +INPUT_DEFAULT_RIGHT_SIZE_PADDING.replace(/[^.|\d]+/g, '') * 4;

// !!This setup is temporary. We need this, but it has yet to be designed to take the error/loading/success
// into account. When designs are ready, we will need to revise. however the logic is such that we should be
// able to drop any content on right hand side, and the input will work correctly
export function useAdjustRightPaddingBasedOnRightSideContent(
  forwardedRef: ForwardedRef<HTMLInputElement>,
) {
  const ref = React.useRef<HTMLInputElement>(null);
  const rightSideContentRef = React.useRef<HTMLSpanElement>(null);

  React.useEffect(() => {
    if (!ref.current) return;

    if (typeof forwardedRef === 'function') {
      forwardedRef(ref.current);
    } else if (forwardedRef) {
      forwardedRef.current = ref.current;
    }

    if (!rightSideContentRef.current) return;

    const rightSideContentParentBoundingClentRect =
      rightSideContentRef.current.offsetParent?.getBoundingClientRect();

    const rightSideContentParentRight =
      rightSideContentParentBoundingClentRect?.right ?? 0;
    const rightSideContentBoundingClientRect =
      rightSideContentRef.current?.getBoundingClientRect();

    const rightSideContentRight = rightSideContentBoundingClientRect.right;

    const rightSideContentDistanceFromInputRightSide =
      rightSideContentParentRight - rightSideContentRight;

    // input right padding = initial padding + right side content distance from input right side + right side content width
    const rightSideContentWidth = rightSideContentBoundingClientRect.width ?? 0;
    ref.current.style.paddingRight = `${INPUT_DEFAULT_RIGHT_SIZE_PADDING_NUMERIC_VALUE + rightSideContentWidth + rightSideContentDistanceFromInputRightSide}px`;
  }, [forwardedRef]);

  return { ref, rightSideContentRef };
}
